import React from 'react';
import PropTypes from 'prop-types';
import './NavBox.scss';

const NavBox = ({ title, menuItems, onSelectedItem, activeItemName, activeSectionName, withSubTitles = false }) => {
    return withSubTitles ?
    (
        <div className="navbox">
            <div className="navbox-header">{title}</div>
            {        
                menuItems.map(item => {
                    const itemClass = item.key === activeItemName && activeSectionName === title ? "navbox-item active" : "navbox-item";
                    const indentClass = item.indent ? "navbox-item-idented" : "";

                    return <div 
                        className={`${itemClass} ${indentClass}`} 
                        key={item.key} 
                        onClick={() => onSelectedItem(title, item.key)}
                    >
                        <div className='navbox-item-title'>{item.title}</div>
                        <div className='navbox-item-subtitle'>{item.subTitle}</div>
                    </div>
                })
            }
        </div>
    )
    :
    (
        <div className="navbox">
            <div className="navbox-header">{title}</div>
            {        
                menuItems.map(item => 
                    <div 
                        className={(activeItemName && item.toLowerCase() === activeItemName.toLowerCase()) && activeSectionName === title ? "navbox-item active" : "navbox-item"} 
                        key={item} 
                        onClick={() => onSelectedItem(title, item)}
                    >
                        <div className='navbox-item-title'>
                            {item.split("_").join(" ")}
                        </div>
                    </div>
                )
            }
        </div>
    );
}

NavBox.propTypes = {
    title: PropTypes.string.isRequired,
    menuItems: PropTypes.array.isRequired,
    onSelectedItem: PropTypes.func.isRequired,
    activeItemName: PropTypes.string,
    activeSectionName: PropTypes.string,
    withSubTitles: PropTypes.bool
};

export default NavBox;
